module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Fm01"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Fm02"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Fm03"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Fm04"
    }
  }, [_vm._v("Order of Precedence")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_Fm05"
    }
  }, [_vm._v("A Short History of the Badge in the British Army")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Fm06"
    }
  }, [_vm._v("How to use this Book")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_Chapter01"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1")])]), _vm._v(" Uniforms and Badges in Date Order and Some Tips to Help with Dating")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2")])]), _vm._v(" Birds and Wings")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3")])]), _vm._v(" Bugle Horns")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4")])]), _vm._v(" Castles")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5")])]), _vm._v(" Circles and Ovals")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6")])]), _vm._v(" Circles and Ovals Surmounted with Crowns")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7")])]), _vm._v(" Coats of Arms and Shields")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8")])]), _vm._v(" Cross")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9")])]), _vm._v(" Dragons")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10")])]), _vm._v(" Feathers")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11")])]), _vm._v(" Figures and Faces")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12")])]), _vm._v(" Flowers and Plants")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13")])]), _vm._v(" Grenades and Flames")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14")])]), _vm._v(" Guns")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15")])]), _vm._v(" Harps")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16")])]), _vm._v(" Horses")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17")])]), _vm._v(" Knives, Daggers and Swords")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/27_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18")])]), _vm._v(" Letters, Monograms and Roman Numerals")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19")])]), _vm._v(" Lions")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20")])]), _vm._v(" Numbers")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 21")])]), _vm._v(" Other Animals")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/31_Chapter22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 22")])]), _vm._v(" Other ‘Things’")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/32_Chapter23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 23")])]), _vm._v(" Sphinx")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/33_Chapter24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 24")])]), _vm._v(" Stags or Deer")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/34_Chapter25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 25")])]), _vm._v(" Stars")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/35_Chapter26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 26")])]), _vm._v(" Sticks, Rifles and Lances")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/36_Chapter27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 27")])]), _vm._v(" Tanks")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/37_Chapter28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 28")])]), _vm._v(" Tigers")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/38_Chapter29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 29")])]), _vm._v(" Wheels")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/39_Chapter30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 30")])]), _vm._v(" Women’s Services")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/40_Chapter31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 31")])]), _vm._v(" Wreaths")])]), _vm._v(" "), _c('h2', {
    staticClass: "toct"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/41_Bm01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Where to go Next and Further Research")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/42_Abbreviations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Abbreviations Used")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/43_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 1")])]), _vm._v(" Cavalry, 1881 to 1922")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/44_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 2")])]), _vm._v(" Former Infantry Numbering System up to 1881 and Subsequent Titles")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/45_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 3")])]), _vm._v(" The Current Order of Precedence")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/46_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 4")])]), _vm._v(" ‘Lost’ Corps")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/47_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 5")])]), _vm._v(" Some Previous Lost Units")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/48_Appendix06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 6")])]), _vm._v(" Modern Regiments, Formation Dates, and their Antecedents (as of 2020)")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/49_Appendix07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 7")])]), _vm._v(" Infantry and Infantry of the Line")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/50_Appendix08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 8")])]), _vm._v(" Looking at Photographs")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/51_Appendix09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 9")])]), _vm._v(" Regimental and Service Numbers")])]), _vm._v(" "), _c('h2', {
    staticClass: "tocc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/52_Appendix10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tc"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Appendix 10")])]), _vm._v(" The Missing Numbers")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/53_Bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14c103a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Toc.vue
// module id = 66
// module chunks = 0